import { UseFormReturn } from "react-hook-form";

import TextEditor from "../../Global/Editors/TextEditor";
import { Card } from "react-bootstrap";

interface IProps {
  formHook: UseFormReturn<any, any>;
}

const BFLNote = ({ formHook }: IProps) => {
  //return <TextEditor multiline={true} label={"Anteckning"} fieldName={"note"} formHook={formHook} />;
  return (
    <Card className="mb-3">
      <Card.Header>Anteckningar</Card.Header>
      <div className="d-flex" style={{ minHeight: "86px" }}>
        <TextEditor multiline={true} label={""} fieldName={"note"} formHook={formHook} />
      </div>
    </Card>
  );
};

export default BFLNote;
